import React from "react";

function About() {
  return (
    <div>
    <section id="about">
      <div className="container mx-auto flex px-10 py-10 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            <em>Hi, I am Harsh!</em>
    <br/>
            <br className="hidden lg:inline-block sm:inline:block" />I love to
            build amazing apps.
          </h1>
          <p className="mb-8 leading-relaxed">
            I have worked as a Front end Developer (ReactJs) and as an Identity and Access Management Consultant
    and have an experience of approx 2.5 years in the IT field 
          </p>
          <div className="flex justify-center">
    <a
              href="/contact"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg"
            >
              Work with me
            </a>
            <a
              href="/projects"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg"
            >
              See My Past Work
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 sm:w-5/6 sm:min-w-sm">
          <img
            style={{ borderRadius: "50%" }}
            className="object-cover object-center rounded"
            alt="hero"
            src="image.png"
          ></img>
        </div>
      </div>
    </section>
    </div>
  );
}

export default About;
